import "./App.scss";

import React from "react";
import logo from "./logo.png";

const App = () => {
  const state = process.env.REACT_APP_PAYMENT_STATE || "success";
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1 className="App-heading">Dziękujemy za Twoją pomoc!</h1>
        {state === "success" && (
          <>
            <h3 className="App-subheading">Wpłata zakończona sukcesem</h3>
            <a
              href="https://aplikacjadrogowskaz.pl/payments/success"
              className="App-button"
              rel="noopener noreferrer"
              target="_blank"
            >
              Wróć do aplikacji
            </a>
          </>
        )}
        {state === "fail" && (
          <>
            <h3 className="App-subheading">
              Niestety, wpłata została zakończona niepowodzeniem. Wróć do
              aplikacji aby ponowić wpłatę.
            </h3>
            <a
              href="https://aplikacjadrogowskaz.pl/payments/error"
              className="App-button"
              rel="noopener noreferrer"
              target="_blank"
            >
              Wróć do aplikacji
            </a>
          </>
        )}
      </header>
    </div>
  );
};

export default App;
